import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ResourcesTabParamList, useGoBack } from '../../../../../utils/appNavigationNames';
import { CareTeamActionButtonFrom } from '../../../../shared/CareTeamForm';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { useOrganizationId } from '../../../../../hooks/api/useOrganization';
import useOrganizationCareTeamMembers from '../../../../../hooks/api/useOrganizationCareTeamMembers';
import { CareTeamMemberDetails } from '../../../../../primary-record-types/apiTypes/medicalProfileService';

export type AddCareTeamMemberOwnProps = {};

export type AddCareTeamMemberNavigatorProps = {
    route: RouteProp<ResourcesTabParamList, 'edit-care-team-member'>;
};

export type AddCareTeamMemberProps = AddCareTeamMemberOwnProps & AddCareTeamMemberNavigatorProps;

const AddCareTeamMember: React.FC<AddCareTeamMemberProps> = ({ route }) => {
    const goBack = useGoBack();
    const organizationId = useOrganizationId();
    const {
        updateCareTeamMember,
        isUpdatingCareTeamMember,
        organizationCareTeamMember,
        isLoadingOrganizationCareTeamMember,
    } = useOrganizationCareTeamMembers({
        onUpdateCareTeamMember: goBack,
        organizationCareTeamMemberId: route.params.careTeamMemberId,
    });

    return (
        <AnimateLoadedContent
            isLoading={isLoadingOrganizationCareTeamMember || !organizationCareTeamMember || isUpdatingCareTeamMember}
        >
            {() => (
                <CareTeamActionButtonFrom
                    onSubmit={(updated) => {
                        updateCareTeamMember({
                            careTeamMemberId: route.params.careTeamMemberId,
                            update: updated,
                        });
                    }}
                    isSubmitting={isUpdatingCareTeamMember}
                    source={{
                        source: 'organization',
                        organizationId,
                    }}
                    careTeamMemberId={route.params.careTeamMemberId}
                    careTeamMemberDetails={(organizationCareTeamMember as CareTeamMemberDetails) || undefined}
                    shouldRecordAddCareTeamMember
                />
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(AddCareTeamMember);
